import { useMemo } from 'react';
import { useApolloClient, gql } from '@apollo/client';
import { useI18n, useSelector } from '~Hooks';
import { useEntryFinder } from '~Components/EntryFinder';
import { CompanyCategories } from './__queries__';

export const useItemCategoryMap = () => {
  const client = useApolloClient();
  const findEntryFromId = useEntryFinder();

  const companyId = useSelector((state) => state.company);
  const { i18n } = useI18n();

  const itemCategoryMap = useMemo(() => {
    const data = client.readFragment<CompanyCategories>({
      fragment: gql`
        fragment CompanyCategories on Company {
          id
          categories {
            id
            items(filter: { deleted: false }) {
              id
            }
            nameLang {
              id
              se
              en
              es
              no
            }
          }
        }
      `,
      id: companyId,
    });

    if (!data?.categories) {
      console.error('Failed to load');
      return {};
    }

    const itemMap = data.categories.reduce(
      (obj, category) => {
        category.items
          .filter((item) => findEntryFromId(item.id))
          .forEach((item) => {
            obj[item.id] = {
              id: category.id,
              name: i18n(category.nameLang),
            };
          });

        return obj;
      },
      {} as Record<
        string,
        {
          id: string;
          name: string;
        }
      >,
    );

    return itemMap;
  }, [companyId, client, i18n, findEntryFromId]);

  return itemCategoryMap;
};
